import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import CallerPostCodeIsForm from './CallerPostCodeIsForm'

const stateToProps = ({ form }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(CallerPostCodeIsForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/CallerPostCodeIs/CallerPostCodeIsForm.container.js